import React from 'react';

const ReportWarrantyRepair = React.lazy(() => import('pages/ReportWarrantyRepair/ReportWarrantyRepairPage'));

const ReportWarrantyRepairRoutes = [
  {
    path: '/report-warranty-repair',
    exact: true,
    name: 'Báo cáo bảo hành',
    function: 'REPORT_WARRANTY_REPAIR',
    component: ReportWarrantyRepair,
  },
];

export default ReportWarrantyRepairRoutes;
